<template>
  <div id="CreateUpdateRouteDetails">
    <CreateUpdateRoute :route="routeData" :routeDialog="routeDialog" @cancel="routeDialog=false"
                       @saveRoute="saveRoute" v-if="routeDialog"></CreateUpdateRoute>
    <CreateUpdateOrganization :saveOrganizationDialog="saveOrganizationDialog"
                              @cancel="saveOrganizationDialog=false" @saveOrganization="appendShopInRoute"
                              v-if="saveOrganizationDialog"></CreateUpdateOrganization>
    <v-dialog fullscreen persistent v-model="routeDetailDialog">
      <v-card style="background: #E9ECEE">
        <v-app-bar elevation="0">
          <v-container v-if="routeData" class="d-flex">
            <div>
              <div class="text-caption grey--text text--darken-1">Route Name</div>
              <div class="text-body-1">{{ routeData.name }}</div>
            </div>
            <div class="ml-15">
              <div class="text-caption grey--text text--darken-1">Salesman</div>
              <div class="text-body-1">{{ routeData.Driver ? routeData.Driver.name : '-' }}</div>
            </div>
            <div class="ml-15">
              <div class="text-caption grey--text text--darken-1">Vehicle</div>
              <div class="text-body-1" v-if="routeData.Vehicle">{{ routeData.Vehicle.name }}
                ({{ routeData.Vehicle.platNo }})
              </div>
              <div v-else>-</div>
            </div>
            <v-spacer></v-spacer>
            <div>
              <v-btn fab small @click="editRoute"  elevation="0">
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
              <v-btn fab small elevation="0" @click="cancel" class="ml-3">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </v-container>

        </v-app-bar>

        <v-container class="mt-7">
          <v-card elevation="0" class="pa-5">
            <div class="d-flex align-center">
              <div>
                <h4 class="text-h6">Select Shops</h4>
                <p class="text-body-2 grey--text text--darken-1 mb-0">Drag & Drop shops to select shops for this route and for correct
                  sequencing.</p>
              </div>
              <v-spacer></v-spacer>
              <v-btn small @click="saveOrganizationDialog=true" class="primary elevation-0"><v-icon size="16" class="mr-2">mdi-plus</v-icon> NEW SHOP</v-btn>
            </div>

            <v-card-text v-if="routeData" style="height: calc(100vh - 210px)">
              <v-row class="mt-3" style="overflow-x: auto">

                <v-col style="height: 68vh; background: #F5F5F5; border-radius: 10px; overflow-x: hidden; position: relative" class="pt-0 px-0">
                  <div style="background: #EAEAEA; position: sticky; top: 0px; z-index: 9999" class="d-flex align-center px-3 mb-3">
                    <v-text-field class="my-3 mr-10" clearable dense flat hide-details style="max-width: 300px; background: white" label="Search Shops"
                                  outlined v-model="searchOrganization"></v-text-field>
                    <v-spacer></v-spacer>
                  <h4 class="text-h5 black--text">{{ organizations.length }}</h4>
                  </div>
                  <draggable :list="filteredOrganizations" group="shops" class="px-3" style="min-height: 40vh; ">
                    <v-list-item class="shop-list white mb-2 " style="width: 100%; cursor: grab" :key="index"
                                 v-for="(element,index) in filteredOrganizations">
                      <div style="width: 100%" class="d-flex py-3">
                        <div style="width: 100%">
                          <h3 class="font-weight-medium text-body-2">{{ element.name }}</h3>
                          <div class="d-flex justify-space-between" style="width: 100%">
                          <p class="grey--text mb-0 text--darken-1 d-block text-caption">{{ element.mobile }}</p>
                            <p class="grey--text mb-0 text--darken-1 d-block"
                                  style="font-size: 13px">{{ element.Type.type }}</p>
                          </div>
                        </div>
                      </div>
                    </v-list-item>
                  </draggable>
                </v-col>

                <v-col style="height: 68vh; background: #F5F5F5; border-radius: 10px; overflow-x: hidden; position: relative" class="pt-0 px-0 ml-5">
                  <div style="background: #EAEAEA; height: 64px; position: sticky; top: 0px; z-index: 9999" class="d-flex align-center px-3 mb-3">
                    <h4 class="text-subtitle-1 black--text">Selected Shops</h4>
                    <v-spacer></v-spacer>
                    <h4 class="text-h5 black--text">{{ selectedShops.length }}</h4>
                  </div>
                  <draggable @change="saveRouteDetails" :list="selectedShops" class="px-3" group="shops" style="min-height: 40vh; ">
                    <v-list-item class="shop-list white mb-2" style="width: 100%; cursor: grab" :key="index"
                                 v-for="(element,index) in selectedShops">
                      <div style="width: 100%" class="d-flex py-3">
                        <div class="mr-3"><h3 class="font-weight-medium">{{ index + 1 }}.</h3></div>
                        <div style="width: 100%">
                          <h3 class="font-weight-medium text-body-2">{{ element.name }}</h3>
                          <div class="d-flex justify-space-between align-center" style="width: 100%">
                            <p class="grey--text text--darken-1 mb-0 text-caption" style="font-size: 13px">{{ element.mobile }}</p>
                            <p class="grey--text text--darken-1 mb-0" style="font-size: 13px">{{element.Type.type}}</p>
                          </div>
                        </div>
                      </div>
                    </v-list-item>
                  </draggable>
                </v-col>

              </v-row>
            </v-card-text>
          </v-card>
        </v-container>

      </v-card>
      <ConfirmationDialog :confirmationMessage="confirmMsg" @close="confirmationDialog=false;confirmMsg = 'Confirm! '"
                          @confirm="cancel" v-if="confirmationDialog"></ConfirmationDialog>
    </v-dialog>
  </div>
</template>

<script>
import {GET_ORGANIZATIONS_BY_TYPE} from '@/graphql/queries/Organizations'
import draggable from 'vuedraggable'
import {GET_ROUTE_SHOPS_BY_ID} from '@/graphql/queries/Routes'
import {CREATE_UPDATE_ROUTE_SHOPS} from '@/graphql/mutations/Routes'
import {deleteRecordById} from '@/graphql/mutations/Common'
import ConfirmationDialog from '@/components/Common/ConfirmationDialog'
import CreateUpdateRoute from '@/components/RouteManagement/CreateUpdateRoute'
import {GET_ROUTE_BY_ID} from '@/graphql/subscriptions/Routes'
import CreateUpdateOrganization from '@/components/OrganizationManagement/CreateUpdateOrganization'

export default {
  name: 'CreateUpdateRouteDetails',
  components: {CreateUpdateOrganization, CreateUpdateRoute, ConfirmationDialog, draggable},
  props: {
    route: {type: Object, default: null},
    routeDetailDialog: {type: [Boolean], default: false},
  },
  data() {
    return {
      searchOrganization: '', organizations: [], filteredOrganizations: [],
      routeDialog: false, routeData: null, saveOrganizationDialog: false,
      remainingShops: [], selectedShops: [], selectedShopsIds: [],
      loggedInUser: JSON.parse(localStorage.user),
      confirmMsg: '', confirmationDialog: false, deleteShopId: null,
      rules: {nameRequired: value => !!value || 'Route Required.'},
    }
  },
  watch: {
    searchOrganization(val) {
      if (val)
        this.filteredOrganizations = this.organizations.filter(organization => {
          return (organization.name.toLowerCase().indexOf(val.toLowerCase()) !== -1 ||
              organization.mobile.toLowerCase().indexOf(val.toLowerCase()) !== -1)
        })
      else
        this.filteredOrganizations = this.organizations
    },
  },
  apollo: {
    $subscribe: {
      Route: {
        query: GET_ROUTE_BY_ID, fetchPolicy: 'network-only',
        skip() {
          return !this.route
        },
        variables() {
          return {id: this.route.id}
        },
        result({data, loading}) {
          if (!loading) {
            this.routeData = JSON.parse(JSON.stringify(data.Routes[0]))
            this.getOrgAndRouteShops()
            this.$forceUpdate()
          }
        },
      },
    },
  },
  methods: {
    async getOrgAndRouteShops() {
      let res1 = await this.$apollo.query({
        query: GET_ROUTE_SHOPS_BY_ID, fetchPolicy: 'network-only',
        variables: {routeId: this.route.id},
      })
      if (res1.data) {
        this.selectedShopsIds = []
        this.selectedShops = []
        res1.data.RouteShops.forEach(shop => {
          this.selectedShops.push({
            id: shop.organizationId, lat: shop.lat, uniqueId: shop.id, long: shop.long,
            mobile: shop.Organization.mobile, name: shop.Organization.name, zone: shop.Organization.zone,
            Type: shop.Organization.Type,
          })
          this.selectedShopsIds.push(shop.organizationId)
        })
        this.$forceUpdate()
        let res2 = await this.$apollo.query({
          query: GET_ORGANIZATIONS_BY_TYPE, fetchPolicy: 'network-only',
          variables: {parentOrgId: this.loggedInUser.organization.id, orgIds: this.selectedShopsIds},
        })
        if (res2.data) {
          this.organizations = JSON.parse(JSON.stringify(res2.data.Organizations))
          this.filteredOrganizations = JSON.parse(JSON.stringify(res2.data.Organizations))
          this.$forceUpdate()
        }
      }
    },
    editRoute() {
      this.routeDialog = true
    },
    saveRoute() {
      this.$emit('saveRoute')
      this.routeDialog = false
    },
    async saveRouteDetails(actionData) {
      let actionType = Object.keys(actionData)[0]
      let actionId = actionData[actionType].element.uniqueId
      // eslint-disable-next-line no-prototype-builtins
      if (actionData.hasOwnProperty('removed')) {
        this.deleteShopId = actionId
        this.selectedShops.splice(this.selectedShops.findIndex(item => item.uniqueId === actionId), 1)
        this.$forceUpdate()
        await deleteRecordById(this, this.deleteShopId, 'RouteShops').then(async () => {
          await this.saveRouteShops()
        })
      } else {
        await this.saveRouteShops()
      }
    },
    async appendShopInRoute(data) {
      this.selectedShops.push(data)
      await this.saveRouteShops()
    },
    async saveRouteShops() {
      async function removeDuplicates(myArr, prop) {
        return myArr.filter((obj, pos, arr) => {
          return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos
        })
      }

      let routeShops = []
      await removeDuplicates(this.selectedShops, 'id').then(shops => {
        this.selectedShops = JSON.parse(JSON.stringify(shops))
        this.selectedShops.forEach((shop, index) => {
          routeShops.push({
            organizationId: shop.id, routeId: this.routeData.id,
            lat: shop.lat, long: shop.long, sequence: index + 1,
          })
          if (shop.uniqueId)
            routeShops[index]['id'] = shop.uniqueId
        })
      }).then(async () => {
        let routeShops_on_conflict_rule = {
          constraint: 'RouteShops_pkey', update_columns: ['organizationId', 'routeId', 'lat', 'long', 'sequence'],
        }
        let response = await this.$apollo.mutate({
          mutation: CREATE_UPDATE_ROUTE_SHOPS,
          variables: {routeShops: routeShops, routeShops_on_conflict_rule: routeShops_on_conflict_rule},
        })
        if (response.data) {
          this.$emit('saveRouteDetails')
          this.saveOrganizationDialog = false
          await this.getOrgAndRouteShops()
        }
      })
    },
    cancel() {
      this.$emit('cancel')
    },
  },
}
</script>

<style scoped>
.v-list {
  padding: 0;
}

.v-list-item {
  min-height: 32px;
}

/deep/ .v-list-item:after {
  display: none;
}

.shop-list:hover {
  background: rgba(220, 220, 220, 0.4) !important;
  cursor: pointer;
}
</style>
